export const AUTH_TOKEN_KEY = 'buddys_token'
export const AUTH_USER_KEY = 'buddys_user'

const AUTH_KEY_PATTERN = /^(buddys_token|buddys_user|buddys_session)/

function removeMatchingKeys(store: Storage) {
  const keys: string[] = []
  for (let i = 0; i < store.length; i++) {
    const key = store.key(i)
    if (key && AUTH_KEY_PATTERN.test(key)) keys.push(key)
  }
  for (const key of keys) store.removeItem(key)
}

/** Drop every auth/session key. Theme and cart stay. */
export function clearAuthStorage() {
  try {
    localStorage.removeItem(AUTH_TOKEN_KEY)
    localStorage.removeItem(AUTH_USER_KEY)
    removeMatchingKeys(localStorage)
  } catch {
    // private mode / blocked storage
  }
  try {
    sessionStorage.removeItem(AUTH_TOKEN_KEY)
    sessionStorage.removeItem(AUTH_USER_KEY)
    removeMatchingKeys(sessionStorage)
  } catch {
    // sessionStorage unavailable
  }
}

export function readStoredToken(): string | null {
  try {
    return localStorage.getItem(AUTH_TOKEN_KEY)
  } catch {
    return null
  }
}

export function writeAuthSession(token: string, userJson: string) {
  localStorage.setItem(AUTH_TOKEN_KEY, token)
  localStorage.setItem(AUTH_USER_KEY, userJson)
}
